<div [ngStyle]="{ 'cursor': isPreviewMode() || readonly() ? 'default' : 'pointer' }"
     class="icon-wrapper"
     (click)="onClicked(ReactionType.Heart)"
     aria-hidden="true">
  <app-icon class="icon" [name]="isLiked() ? 'like-solid' : 'like'"></app-icon>
  <div class="font-medium">{{ heartCounter() |  number:'1.0-1':'en-US' }}</div>
</div>
<div style="cursor: default" class="icon-wrapper" (click)="onClicked(ReactionType.Comments)" aria-hidden="true">
  <app-icon class="icon" [name]="addedComment() ? 'chat-solid': 'chat'"></app-icon>
  <div class="font-medium">{{ chatCounter() | number:'1.0-1':'en-US' }}</div>
</div>

